<template>
  <div class="flex w-full items-center gap-1 py-4 text-lg font-semibold">
    <div class="font-bold">
      {{ review.entity?.value?.project?.name }}
    </div>
    /
    {{ review.entity.value.reviewSeries.name }}
  </div>
</template>
<script lang="ts" setup>
import { ReviewKey } from '../use-review'
import { injectStrict } from '@app/utils/injectStrict'

const review = injectStrict(ReviewKey)
</script>
